export default "__VITE_ASSET__4ee1d7c9__"